import { portalTypes } from '@/constants'
import { needsRefund } from '@/helpers'
import routes from '@/Router/routes.constants'

import { steps } from './constants'

const getStepsByFlow = ({ portalType, orderType, summaryTotalAmount }) => {
  if ([portalTypes.cancellations, portalTypes.returnToSender].includes(portalType)) return steps.cancellations
  if (orderType === 'refund') return steps.refund
  if (needsRefund(summaryTotalAmount)) return steps.exchange.withRefund

  return steps.exchange.withoutRefund
}

export const getProcessSteps = ({ portalType, orderType, summaryTotalAmount, isRefundStepSkipped }) => {
  const processSteps = getStepsByFlow({ portalType, orderType, summaryTotalAmount })

  if (!isRefundStepSkipped) return processSteps

  return processSteps.filter(step => step !== routes.refundSelectionPage)
}
